/* @ngInject */
export default function (APIService) {
	return {
		...APIService.service('notices'),

		getVisible: () => {
			return {
				...APIService.service('notices/visible'),
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/factories/notices/index.js